<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <!--<app-content-header [contentHeader]="contentHeader"></app-content-header>-->
      <ng-container *ngIf="contentHeader">
          <div class="content-header row">
              <div class="content-header-left col-12 mb-2">
                  <div class="row breadcrumbs-top">
                      <div class="col-lg-8">
                          <h2 class="content-header-title mb-0">{{ contentHeader.headerTitle | translate }}</h2>
                          <app-breadcrumb *ngIf="contentHeader?.breadcrumb?.links.length > 0" [breadcrumb]="contentHeader.breadcrumb"></app-breadcrumb>
                      </div>
                      <div class="col-lg-4 text-right pt-1">
                          <button class="btn btn-primary" (click)="syncPayedInvoices()" has_capability="view_invoice_detail">
                              {{ 'SYNC_PAYED_INVOICES' |translate }}
                          </button>
                      </div>
                  </div>
              </div>
          </div>
      </ng-container>

      <ngb-alert *ngIf="invoices_with_errors.length" [type]="'danger'" [dismissible]="true" class="card w-100 m-0 active mb-2">
          <h4 class="alert-heading py-1">{{ 'INVOICES_SYNC_WITH_ERROR' | translate }} </h4>
          <section class="px-1 alert-body">
              <p>{{ 'INVOICES_WITH_THESE_IDS_ARE_IN_ERROR' | translate }}</p>
              <ul>
                  <li *ngFor="let fc of invoices_with_errors">{{ fc }}</li>
              </ul>
          </section>
      </ngb-alert>

    <div class="card">
      <div class="card-body w-100 p-2 mb-0">
        <div class="row">
          <div class="col-xl-3 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <input type="search" id="datatable-search-input" [placeholder]="'SEARCH' | translate" class="form-control" [(ngModel)]="searchKeyword" (ngModelChange)="filter()" />
          </div>
          <div class="col-xl-3 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <ng-select [(ngModel)]="filterStatus" [closeOnSelect]="true" [openOnEnter]="true" [searchable]="false" [virtualScroll]="true" (clear)="filterStatus=''" [clearable]="filterStatus.length>0" (ngModelChange)="filter()">
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="!filterStatus.length">{{ 'STATUS.STATUS' | translate }}: {{ 'ALL' | translate }}</span>
                <span class="font-small-4 font-weight-normal pr-2" *ngIf="filterStatus.length">{{ 'STATUS.STATUS' | translate }}: {{ item | uppercase | translate }}</span>
              </ng-template>
              <ng-option [value]="''">{{ "ALL" | translate }}</ng-option>
              <ng-option *ngFor="let status of ['expired', 'not_cashed', 'cashed']" [value]="status">{{ status | uppercase | translate }}</ng-option>
            </ng-select>
          </div>
          <div class="col-xl-3 col-12" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <ng-select [(ngModel)]="filterCustomer" [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" (clear)="filterCustomer = {id: null, name: null}" [clearable]="!!filterCustomer.id" (ngModelChange)="filter()">
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2">{{ "CUSTOMER" | translate }}: {{ !item.id ? ("ALL" | translate) : item.name }}</span>
              </ng-template>
              <ng-option [value]="customer" *ngFor="let customer of customers">
                <span class="font-small-4 font-weight-normal pr-2">{{ customer.name }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-3 text-right" *ngIf="_utilService.isDesktop">
            <div class="d-inline-block">
              <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
            </div>
          </div>
          <div class="col-xl-3 col-12 pt-05" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <label class="mb-0">&nbsp;</label>
            <ng-select [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [(ngModel)]="filterInvoiceType" (clear)="filterInvoiceType = {id: null, name: null}" [clearable]="!!filterInvoiceType.id" (ngModelChange)="filter()">
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2">{{ "INVOICE_TYPE" | translate }}: {{ !item.id ? ("ALL" | translate) : item.name }}</span>
              </ng-template>
              <ng-option [value]="type" *ngFor="let type of invoice_document_types">
                <span class="font-small-4 font-weight-normal pr-2">{{ type.name }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-3 col-12 pt-05" [ngClass.sm]="'mb-1'" [ngClass.md]="'mb-1'">
            <label class="mb-0">&nbsp;</label>
            <ng-select [closeOnSelect]="true" [openOnEnter]="true" [virtualScroll]="true" [(ngModel)]="filterResource" (clear)="filterResource = 'all'" [clearable]="filterResource!='all'" (ngModelChange)="filter()">
              <ng-template ng-label-tmp let-item="item">
                <span class="font-small-4 font-weight-normal pr-2">{{ "RESOURCE_TYPE" | translate }}: {{ filterResource.toUpperCase() | translate }}</span>
              </ng-template>
              <ng-option value="all">
                <span class="font-small-4 font-weight-normal pr-2">{{ 'ALL' | translate }}</span>
              </ng-option>
              <ng-option value="employee">
                <span class="font-small-4 font-weight-normal pr-2">{{ 'EMPLOYEE' | translate }}</span>
              </ng-option>
              <ng-option value="product">
                <span class="font-small-4 font-weight-normal pr-2">{{ 'PRODUCT' | translate }}</span>
              </ng-option>
            </ng-select>
          </div>
          <div class="col-xl-2 col-12 mt-05">
            <label class="mb-0">{{ 'MONTH_OF_ISSUE' | translate }}</label>
            <select [(ngModel)]="filterMonth" id="monthYear" class="form-control pr-3 text-capitalize" (ngModelChange)="filter()">
              <option selected disabled>{{ "MONTH" | translate }}</option>
              <option value="-1">{{ "ALL" | translate }}</option>
              <option *ngFor="let month of months; let i = index" [value]="i">{{ month }}</option>
            </select>
          </div>
          <div class="col-xl-2 col-12 mt-05">
            <label class="mb-0">{{ 'YEAR_OF_ISSUE' | translate }}</label>
            <select [(ngModel)]="filterYear" class="form-control pr-3" (ngModelChange)="load()">
              <option selected disabled value="all">{{ "YEAR" | translate | titlecase }}</option>
              <option *ngFor="let year of years">{{ year }}</option>
            </select>
          </div>
        </div>
      </div>
      <div class="card-body px-0 py-0">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [scrollbarH]="true"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [rowHeight]="_utilService.isDesktop ? 50 : 150"
          [limit]="tableLimit"
          [footerHeight]="50"
          [rows]="filteredListElements"
        >
          <ngx-datatable-column [name]="'DOCUMENT_NUMBER' | translate" prop="document_number" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.document_number }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CUSTOMER' | translate" prop="client.name" width="200" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a routerLink="/dashboard/customer/{{ row.client.id }}" target="_blank">{{ row.client.name }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'DOCUMENT_DATE' | translate" prop="document_date" width="120" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.document_date | date: "dd/MM/yyyy" }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'EXPIRATION_DATE' | translate" prop="expiration_date" width="100" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.expiration_date | date: "dd/MM/yyyy" }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CASHED_DATE' | translate" prop="cashed_date" width="90" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span *ngIf="row.cashed">{{ row.cashed_date | date: "dd/MM/yyyy" }}</span>
              <span *ngIf="!row.cashed">-</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'AMOUNT' | translate" prop="total_amount" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">{{ row.invoice_type.name.toLowerCase().includes('di credito') ? '-' : '' }}{{ row.total_amount | currency: "EUR" }}</ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'RESOURCES' | translate" width="120" [sortable]="false" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                <span class="mr-1" *ngIf="row.users_in_rows?.length == 1" placement="left" [ngbTooltip]="(row.users_names_in_rows || []).join(', ')">
                  <i [data-feather]="'user'" size="19"></i>
                </span>
                <span class="mr-1" *ngIf="row.users_in_rows?.length > 1" placement="left" [ngbTooltip]="(row.users_names_in_rows || []).join(', ')">
                    <i [data-feather]="'users'" size="19"></i>
                </span>
                <span class="mr-1" *ngIf="row.products_in_rows?.length > 0" placement="left" [ngbTooltip]="(row.products_in_rows || []).join(', ')">
                    <i [data-feather]="'package'" size="19"></i>
                </span>
                <span class="mr-1" *ngIf="row.users_in_rows.length < 1 && row.products_in_rows.length < 1" placement="left" [ngbTooltip]="row.rows[0].description">
                  <i [data-feather]="'info'" size="19"></i>
                </span>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'STATE' | translate" prop="status" [sortable]="true" *ngIf="_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span *ngIf="row.cashed" class="badge badge-pill badge-success">{{ 'CASHED' | translate }}</span>
              <span *ngIf="row.expired && !row.cashed" class="badge badge-pill badge-danger">{{ 'EXPIRED' | translate }}</span>
              <span *ngIf="!row.cashed && !row.expired" class="badge badge-pill badge-warning">{{ 'NOT_CASHED' | translate }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ACTIONS' | translate" width="60" [sortable]="false" has_capability="set_paid_invoice">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex">
                <app-invoice-set-as-payed *ngIf="!row.cashed" [invoice_id]="row.id" (onSetAsPayed)="load()"></app-invoice-set-as-payed>
                <button class="border-0 bg-transparent" type="button" (click)="invoiceSelectedId = row.id" [ngbTooltip]="'VIEW' | translate" has_capability="view_invoice_detail">
                  <i class="text-primary" [data-feather]="'eye'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <!--mobile - tablet-->
          <ngx-datatable-column [name]="'NAME' | translate" prop="name" width="700" [sortable]="true" *ngIf="!_utilService.isDesktop">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile align-items-center">
                <div class="col-12">
                  <span class="font-weight-bold">{{ "DOCUMENT_NUMBER" | translate }}: </span>
                  <span>{{ row.document_number }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "CUSTOMER" | translate }}: </span>
                  <a routerLink="/dashboard/customer/{{ row.client.id }}" target="_blank">{{ row.client.name }}</a>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "DOCUMENT_DATE" | translate }}: </span>
                  <span>{{ row.document_date | date: "dd/MM/yyyy" }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "AMOUNT" | translate }}: </span>
                  <span>{{ row.total_amount | currency: "EUR" }}</span>
                </div>
                <div class="col-12">
                  <span class="font-weight-bold">{{ "STATE" | translate }}: </span>
                  <span class="badge badge-pill" [ngClass]="{
                'badge-warning': row.status==='processing',
                'badge-success': row.status==='success',
                'badge-danger': row.status==='failed'
              }">{{ row.status.toUpperCase() | translate }}</span>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
        <h4 class="px-2 pb-1 pt-1">{{ 'TOTAL_PROFIT' | translate }}: {{ sumTotalsAmount | currency: 'EUR' }}</h4>
      </div>
    </div>

    <section id="apex-line-charts" *ngIf="listElements.length > 0 && chartData && chartTotal > 0">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-header d-flex flex-sm-row flex-column justify-content-md-between align-items-start justify-content-start">
              <div>
                <h4 class="card-title mb-25">{{ 'BALANCE' | translate }}</h4>
                <span class="card-subtitle text-muted">{{ 'INVOICES_BALANCE_DIVIDED_BY_MONTHS' | translate }}</span>
              </div>
              <div class="d-flex align-items-center flex-wrap mt-sm-0 mt-1">
                <h5 class="font-weight-bolder mb-0 mr-1">{{ chartTotal | currency: 'EUR' }}</h5>
                <div class="badge badge-light-secondary" [ngbTooltip]="'LAST_MONTH_TREND' | translate">
                  <i class="text-{{balancePercentage.color}} font-small-3" [data-feather]="'arrow-'+balancePercentage.icon"></i>
                  <span class="align-middle">{{ balancePercentage.number }}%</span>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div id="line-chart" #apexLineChartRef *ngIf="chartData">
                <apx-chart
                  [series]="[{data: chartData}]"
                  [chart]="{
                    height: 400,
                    width: isMenuToggled === false ? apexLineChartRef.offsetWidth : apexLineChart.chart.width,
                    type: 'line',
                    zoom: {
                      enabled: false
                    },
                    toolbar: {
                      show: false
                    }
                  }"
                  [xaxis]="apexLineChart.xaxis"
                  [yaxis]="apexLineChart.yaxis"
                  [stroke]="apexLineChart.stroke"
                  [tooltip]="apexLineChart.tooltip"
                  [colors]="apexLineChart.colors"
                  [dataLabels]="apexLineChart.dataLabels"
                  [grid]="apexLineChart.grid"
                ></apx-chart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
</div>
<app-invoice-modal-detail [invoiceId]="invoiceSelectedId" *ngIf="!!invoiceSelectedId" (onclose)="invoiceSelectedId = null"></app-invoice-modal-detail>
